/**
 * Mini Cart Drawer - REPLICANDO EXATAMENTE o drawer de filtros
 * Usa abordagem simples com classes .open (sem DialogComponent)
 */

document.addEventListener('DOMContentLoaded', function() {
  const cartDrawerToggleButtons = document.querySelectorAll('[data-cart-drawer-toggle]');
  const cartDrawer = document.getElementById('cart-drawer');
  const cartDrawerClose = document.getElementById('cart-drawer-close');
  const cartDrawerOverlay = document.getElementById('cart-drawer-overlay');
  const cartDrawerContinue = document.getElementById('cart-drawer-continue');

  if (!cartDrawer) return;

  // Abrir drawer (será atualizado depois que setupEventDelegation e cartItemManager forem definidos)
  let openCartDrawer = function() {
    cartDrawer.classList.add('open');
    if (cartDrawerOverlay) cartDrawerOverlay.classList.add('open');
    document.body.style.overflow = 'hidden';
    // Seção de cálculo de frete removida temporariamente
    // cloneShippingAppToCart();
  };
  
  // Clonar app de frete da página de produto para o mini cart
  function cloneShippingAppToCart() {
    const shippingContainer = document.getElementById('cart-drawer-shipping-app-container');
    if (!shippingContainer) return;
    
    // Buscar o bloco do app de frete na página
    // O app geralmente cria elementos com classes ou IDs específicos
    const shippingAppSelectors = [
      '[data-app-block*="frete-no-produto"]',
      '[data-app-block*="shipping"]',
      '[id*="frete-no-produto"]',
      '[class*="frete-no-produto"]',
      '[class*="shipping-calc"]',
      '.shipping-calculator',
      '#shipping-calculator'
    ];
    
    let shippingAppElement = null;
    for (const selector of shippingAppSelectors) {
      shippingAppElement = document.querySelector(selector);
      if (shippingAppElement) break;
    }
    
    // Se não encontrou pelos seletores, procurar por elementos com atributos do app
    if (!shippingAppElement) {
      // Buscar elementos que contenham o app de frete (geralmente em seções com blocos de app)
      const allElements = document.querySelectorAll('[data-shopify-app-block], [data-app-block]');
      for (const el of allElements) {
        const appId = el.getAttribute('data-shopify-app-block') || el.getAttribute('data-app-block') || '';
        if (appId.includes('frete-no-produto') || appId.includes('shipping')) {
          shippingAppElement = el;
          break;
        }
      }
    }
    
    // Se encontrou o app, clonar para o mini cart
    if (shippingAppElement) {
      // Limpar container anterior
      shippingContainer.innerHTML = '';
      
      // Clonar o elemento (deep clone para incluir todos os filhos e event listeners)
      const clonedApp = shippingAppElement.cloneNode(true);
      
      // Ajustar estilos para o mini cart
      clonedApp.style.width = '100%';
      clonedApp.style.maxWidth = '100%';
      
      // Adicionar ao container
      shippingContainer.appendChild(clonedApp);
      
      // Re-inicializar scripts do app se necessário
      if (window.freteNoProduto && typeof window.freteNoProduto.init === 'function') {
        window.freteNoProduto.init();
      }
    }
  }

  // Fechar drawer
  function closeCartDrawer() {
    cartDrawer.classList.remove('open');
    if (cartDrawerOverlay) cartDrawerOverlay.classList.remove('open');
    document.body.style.overflow = '';
    
    // Limpar campos de personalização do formulário de produto ao fechar o mini cart
    // Isso garante que ao adicionar um novo produto, não tenha campos residuais
    const productForm = document.querySelector('.product-form');
    if (productForm) {
      const p1 = productForm.querySelector('input[name="properties[_Personalização]"]');
      const p2 = productForm.querySelector('input[name="properties[Texto]"]');
      const p3 = productForm.querySelector('input[name="properties[Fonte]"]');
      
      if (p1) p1.remove();
      if (p2) p2.remove();
      if (p3) p3.remove();
    }
  }

  // Event Listeners - Atribuir a todos os botões toggle
  cartDrawerToggleButtons.forEach(function(button) {
    button.addEventListener('click', openCartDrawer);
  });

  // Usar event delegation no documento para botões de controle do drawer
  // para funcionar mesmo após refreshCartDrawer() substituir o innerHTML
  document.addEventListener('click', function(e) {
    // Botão de fechar
    if (e.target.closest('#cart-drawer-close')) {
      e.preventDefault();
      closeCartDrawer();
      return;
    }
    
    // Overlay
    if (e.target.id === 'cart-drawer-overlay') {
      e.preventDefault();
      closeCartDrawer();
      return;
    }
    
    // Botão continuar comprando
    const continueBtn = e.target.closest('#cart-drawer-continue');
    if (continueBtn) {
      e.preventDefault();
      closeCartDrawer();
      return;
    }
  });

  // Abrir drawer automaticamente ao adicionar produto
  document.addEventListener('theme:cart:update', function(event) {
    // Se veio do formulário de produto (adicionar ao carrinho)
    if (event.detail?.data?.source === 'product-form-component') {
      openCartDrawer();
      // Recarregar conteúdo do drawer
      refreshCartDrawer();
    }
  });

  /**
   * Componente Isolado para Item do Carrinho
   * Cada instância gerencia apenas seu próprio item, garantindo isolamento total
   */
  class CartItemComponent {
    constructor(rootElement) {
      if (!rootElement) {
        throw new Error('CartItemComponent: rootElement é obrigatório');
      }
      
      this._rootElement = rootElement;
      this._itemKey = rootElement.getAttribute('data-item-key') || rootElement.getAttribute('data-key');
      
      if (!this._itemKey) {
        console.error('CartItemComponent: itemKey não encontrado no elemento', rootElement);
        return;
      }
      
      // Buscar elementos dentro do escopo deste componente (usando itemKey para garantir isolamento)
      // IMPORTANTE: Usar método de filtrar por atributo para garantir compatibilidade com caracteres especiais (dois pontos, etc)
      const findElementByDataKey = (selector, attribute = 'data-item-key') => {
        // SEMPRE usar querySelectorAll e filtrar pelo atributo - mais confiável com caracteres especiais
        const allElements = rootElement.querySelectorAll(selector);
        for (const el of allElements) {
          const attrValue = el.getAttribute(attribute);
          if (attrValue === this._itemKey) {
            return el;
          }
        }
        return null;
      };
      
      // Buscar todos os elementos
      this._quantityInput = findElementByDataKey('input[data-item-key]', 'data-item-key');
      this._increaseBtn = findElementByDataKey('[data-cart-qty-increase]', 'data-item-key');
      this._decreaseBtn = findElementByDataKey('[data-cart-qty-decrease]', 'data-item-key');
      this._removeBtn = findElementByDataKey('[data-cart-remove]', 'data-item-key');
      
      // Verificar elementos para fallback se necessário
      const allInputs = rootElement.querySelectorAll('input[data-item-key]');
      const allIncreaseBtns = rootElement.querySelectorAll('[data-cart-qty-increase]');
      const allDecreaseBtns = rootElement.querySelectorAll('[data-cart-qty-decrease]');
      const allRemoveBtns = rootElement.querySelectorAll('[data-cart-remove]');
      
      // Se algum elemento não foi encontrado, tentar fallback
      if (!this._quantityInput || !this._increaseBtn || !this._decreaseBtn) {
        // Tentar fallback: pegar o primeiro elemento de cada tipo dentro do rootElement
        if (!this._quantityInput && allInputs.length === 1) {
          this._quantityInput = allInputs[0];
        }
        if (!this._increaseBtn && allIncreaseBtns.length === 1) {
          this._increaseBtn = allIncreaseBtns[0];
        }
        if (!this._decreaseBtn && allDecreaseBtns.length === 1) {
          this._decreaseBtn = allDecreaseBtns[0];
        }
        if (!this._removeBtn && allRemoveBtns.length === 1) {
          this._removeBtn = allRemoveBtns[0];
        }
      }
      
      // Validar elementos críticos novamente após fallback
      if (!this._quantityInput || !this._increaseBtn || !this._decreaseBtn) {
        console.error('[CartItemComponent] Elementos críticos não encontrados para itemKey:', this._itemKey);
        return;
      }
      
      this._isInitialized = false;
      this._isProcessing = false; // Flag para prevenir execuções duplicadas
    }
    
    /**
     * Inicializar event listeners do componente
     */
    init() {
      if (this._isInitialized) {
        console.warn('[CartItemComponent] Tentativa de inicializar componente já inicializado para itemKey:', this._itemKey);
        return; // Evitar duplicação de listeners
      }
      
      // Verificar se os elementos ainda existem no DOM antes de inicializar
      if (!this._rootElement || !document.body.contains(this._rootElement)) {
        console.error('[CartItemComponent] rootElement não está mais no DOM para itemKey:', this._itemKey);
        return;
      }
      
      // Usar arrow functions para manter o contexto
      this._handleIncrease = (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.updateQuantity(1);
      };
      
      this._handleDecrease = (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.updateQuantity(-1);
      };
      
      this._handleRemove = (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.remove();
      };
      
      // Adicionar listeners - Otimizado (sem logs excessivos)
      const verifyElement = (element) => {
        return element && document.body.contains(element);
      };
      
      if (verifyElement(this._increaseBtn)) {
        this._increaseBtn.removeEventListener('click', this._handleIncrease);
        this._increaseBtn.addEventListener('click', this._handleIncrease);
      }
      
      if (verifyElement(this._decreaseBtn)) {
        this._decreaseBtn.removeEventListener('click', this._handleDecrease);
        this._decreaseBtn.addEventListener('click', this._handleDecrease);
      }
      
      if (verifyElement(this._removeBtn)) {
        this._removeBtn.removeEventListener('click', this._handleRemove);
        this._removeBtn.addEventListener('click', this._handleRemove);
      }
      
      this._isInitialized = true;
    }
    
    /**
     * Atualizar quantidade do item
     * @param {number} change - Mudança na quantidade (+1 ou -1)
     */
    updateQuantity(change) {
      if (!this._itemKey) {
        console.error('[CartItemComponent] updateQuantity: itemKey não definido');
        return;
      }
      
      // Verificar se os elementos ainda estão no DOM, se não, tentar re-encontrar
      let elementsRefreshed = false;
      if (!this._quantityInput || !document.body.contains(this._quantityInput)) {
        if (this._refreshElements()) {
          elementsRefreshed = true;
        } else {
          console.error('[CartItemComponent] updateQuantity: não foi possível re-encontrar elementos para itemKey:', this._itemKey);
          // Remover loader se foi adicionado
          const drawer = document.getElementById('cart-drawer');
          if (drawer) {
            const itemEl = drawer.querySelector(`.cart-mini-item[data-item-key="${this._itemKey}"]`);
            if (itemEl) {
              itemEl.classList.remove('cart-mini-item--loading');
              const loader = itemEl.querySelector('.cart-mini-item__loader');
              if (loader) loader.remove();
              const qtyButtons = itemEl.querySelectorAll('[data-cart-qty-increase], [data-cart-qty-decrease]');
              qtyButtons.forEach(btn => btn.disabled = false);
            }
          }
          return;
        }
      }
      
      // Prevenir execuções duplicadas
      if (this._isProcessing) {
        console.warn('[CartItemComponent] updateQuantity já está em processamento para itemKey:', this._itemKey);
        return;
      }
      
      const currentQuantity = parseInt(this._quantityInput.value) || 0;
      const newQuantity = currentQuantity + change;
      
      if (newQuantity < 0) {
        return; // Não permitir quantidade negativa
      }
      
      // Marcar como processando ANTES de qualquer operação assíncrona
      this._isProcessing = true;
      
      // Garantir que o loader está presente (pode ter sido perdido após refresh)
      if (this._rootElement) {
        this._rootElement.classList.add('cart-mini-item--loading');
        
        // Se os elementos foram re-encontrados, garantir que o loader está presente
        if (elementsRefreshed) {
          const quantityWrapper = this._quantityInput?.closest('.cart-mini-item__quantity');
          if (quantityWrapper && !quantityWrapper.querySelector('.cart-mini-item__loader')) {
            const loader = document.createElement('div');
            loader.className = 'cart-mini-item__loader';
            loader.innerHTML = '<div class="cart-mini-item__spinner"></div>';
            quantityWrapper.appendChild(loader);
          }
        }
        
        // Desabilitar botões durante a operação
        this._setButtonsDisabled(true);
      }
      
      // Buscar carrinho atual e encontrar o item pelo key
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          if (!cart.items || cart.items.length === 0) {
            throw new Error('Carrinho vazio');
          }
          
          // Encontrar o item pelo key (identificador único)
          const itemIndex = cart.items.findIndex(item => item.key === this._itemKey);
          
          if (itemIndex === -1) {
            console.error('[CartItemComponent] Item com key', this._itemKey, 'não encontrado no carrinho. Itens disponíveis:', cart.items.map(i => i.key));
            throw new Error(`Item com key ${this._itemKey} não encontrado no carrinho`);
          }
          
          // Shopify usa índices baseados em 1
          const targetLine = itemIndex + 1;
          console.log('[CartItemComponent] Item encontrado no índice', itemIndex, 'linha', targetLine);
          
          // Atualizar quantidade via API
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              line: targetLine,
              quantity: newQuantity
            })
          })
          .then(response => {
            if (!response.ok) {
              return response.json().then(err => {
                throw new Error(`Erro ao atualizar carrinho: ${response.status} - ${JSON.stringify(err)}`);
              });
            }
            return response.json();
          });
        })
        .then(cart => {
          // Remover estado de loading
          this._setLoadingState(false);
          // Re-habilitar botões
          this._setButtonsDisabled(false);
          // Marcar como não processando
          this._isProcessing = false;
          // Atualizar drawer e contador
          refreshCartDrawer();
          updateCartCount(cart.item_count);
        })
        .catch(error => {
          console.error('[CartItemComponent] Erro ao atualizar quantidade para itemKey', this._itemKey, ':', error);
          // Remover estado de loading em caso de erro
          this._setLoadingState(false);
          // Re-habilitar botões em caso de erro
          this._setButtonsDisabled(false);
          // Marcar como não processando
          this._isProcessing = false;
          // Tentar refresh para sincronizar UI
          refreshCartDrawer();
        });
    }
    
    /**
     * Remover item do carrinho
     */
    remove() {
      if (!this._itemKey) {
        console.error('[CartItemComponent] remove: itemKey não definido');
        return;
      }
      
      // Verificar se os elementos ainda estão no DOM, se não, tentar re-encontrar
      if (!this._removeBtn || !document.body.contains(this._removeBtn)) {
        if (!this._refreshElements()) {
          console.error('[CartItemComponent] remove: não foi possível re-encontrar elementos para itemKey:', this._itemKey);
          // Remover loader se foi adicionado
          if (this._rootElement) {
            this._rootElement.classList.remove('cart-mini-item--loading');
            const removeLoader = this._rootElement.querySelector('.cart-mini-item__remove-loader');
            if (removeLoader) removeLoader.remove();
            if (this._removeBtn) {
              this._removeBtn.classList.remove('cart-mini-item__remove--loading');
              this._removeBtn.disabled = false;
            }
          }
          return;
        }
      }
      
      // Prevenir execuções duplicadas
      if (this._isProcessing) {
        console.warn('[CartItemComponent] remove já está em processamento para itemKey:', this._itemKey);
        return;
      }
      
      // Marcar como processando ANTES de qualquer operação assíncrona
      this._isProcessing = true;
      
      // Loader já foi adicionado no handleCartButtonClick, apenas garantir que está visível
      if (this._rootElement) {
        this._rootElement.classList.add('cart-mini-item--loading');
        if (this._removeBtn) {
          this._removeBtn.classList.add('cart-mini-item__remove--loading');
          this._removeBtn.disabled = true;
        }
      }
      
      // Buscar carrinho atual e encontrar o item pelo key
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          if (!cart.items || cart.items.length === 0) {
            throw new Error('Carrinho vazio');
          }
          
          // Encontrar o item pelo key (identificador único)
          const itemIndex = cart.items.findIndex(item => item.key === this._itemKey);
          
          if (itemIndex === -1) {
            console.error('[CartItemComponent] Item com key', this._itemKey, 'não encontrado no carrinho para remoção');
            throw new Error(`Item com key ${this._itemKey} não encontrado no carrinho`);
          }
          
          // Shopify usa índices baseados em 1
          const targetLine = itemIndex + 1;
          console.log('[CartItemComponent] Item encontrado no índice', itemIndex, 'linha', targetLine, 'para remoção');
          
          // Remover item via API
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              line: targetLine,
              quantity: 0
            })
          })
          .then(response => {
            if (!response.ok) {
              return response.json().then(err => {
                throw new Error(`Erro ao remover item: ${response.status} - ${JSON.stringify(err)}`);
              });
            }
            return response.json();
          });
        })
        .then(cart => {
          // Remover estado de loading
          this._setRemoveButtonLoading(false);
          // Re-habilitar botão
          if (this._removeBtn) {
            this._removeBtn.disabled = false;
          }
          // Marcar como não processando
          this._isProcessing = false;
          // Atualizar drawer e contador
          refreshCartDrawer();
          updateCartCount(cart.item_count);
        })
        .catch(error => {
          console.error('[CartItemComponent] Erro ao remover item com itemKey', this._itemKey, ':', error);
          // Remover estado de loading em caso de erro
          this._setRemoveButtonLoading(false);
          // Re-habilitar botão em caso de erro
          if (this._removeBtn) {
            this._removeBtn.disabled = false;
          }
          // Marcar como não processando
          this._isProcessing = false;
          // Tentar refresh para sincronizar UI
          refreshCartDrawer();
        });
    }
    
    /**
     * Desabilitar/habilitar botões do componente
     * @param {boolean} disabled - true para desabilitar, false para habilitar
     */
    _setButtonsDisabled(disabled) {
      if (this._increaseBtn) {
        this._increaseBtn.disabled = disabled;
      }
      if (this._decreaseBtn) {
        this._decreaseBtn.disabled = disabled;
      }
      if (this._removeBtn) {
        this._removeBtn.disabled = disabled;
      }
    }
    
    /**
     * Adicionar/remover estado de loading visual para quantidade
     * @param {boolean} isLoading - true para mostrar loading, false para remover
     */
    _setLoadingState(isLoading) {
      const itemElement = this._rootElement;
      if (!itemElement) {
        console.warn('[CartItemComponent] _setLoadingState: itemElement não encontrado');
        return;
      }
      
      if (isLoading) {
        // Adicionar classe de loading imediatamente
        itemElement.classList.add('cart-mini-item--loading');
        
        // Adicionar spinner ao input de quantidade de forma síncrona
        // Usar fallback para garantir que sempre encontre o wrapper
        let quantityWrapper = this._quantityInput?.closest('.cart-mini-item__quantity');
        
        // Se não encontrou pelo input, tentar buscar diretamente no itemElement
        if (!quantityWrapper) {
          quantityWrapper = itemElement.querySelector('.cart-mini-item__quantity');
        }
        
        if (quantityWrapper) {
          // Remover loader existente se houver (para garantir limpeza)
          const existingLoader = quantityWrapper.querySelector('.cart-mini-item__loader');
          if (existingLoader) {
            existingLoader.remove();
          }
          
          // Criar e adicionar novo loader imediatamente
          const loader = document.createElement('div');
          loader.className = 'cart-mini-item__loader';
          loader.innerHTML = '<div class="cart-mini-item__spinner"></div>';
          quantityWrapper.appendChild(loader);
          
          // Forçar reflow para garantir renderização imediata
          void loader.offsetHeight;
        } else {
          console.warn('[CartItemComponent] _setLoadingState: quantityWrapper não encontrado para itemKey:', this._itemKey);
        }
      } else {
        itemElement.classList.remove('cart-mini-item--loading');
        // Remover spinner do quantityWrapper
        let quantityWrapper = this._quantityInput?.closest('.cart-mini-item__quantity');
        
        // Fallback: buscar diretamente no itemElement
        if (!quantityWrapper) {
          quantityWrapper = itemElement.querySelector('.cart-mini-item__quantity');
        }
        
        if (quantityWrapper) {
          const loader = quantityWrapper.querySelector('.cart-mini-item__loader');
          if (loader) {
            loader.remove();
          }
        }
      }
    }
    
    /**
     * Adicionar/remover estado de loading visual no botão de remover
     * @param {boolean} isLoading - true para mostrar loading, false para remover
     */
    _setRemoveButtonLoading(isLoading) {
      if (!this._removeBtn) return;
      
      if (isLoading) {
        // Adicionar classe de loading ao botão imediatamente
        this._removeBtn.classList.add('cart-mini-item__remove--loading');
        
        // Remover loader existente se houver (para garantir limpeza)
        const existingLoader = this._removeBtn.querySelector('.cart-mini-item__remove-loader');
        if (existingLoader) {
          existingLoader.remove();
        }
        
        // Criar e adicionar spinner ao botão de remover de forma síncrona
        const loader = document.createElement('div');
        loader.className = 'cart-mini-item__remove-loader';
        loader.innerHTML = '<div class="cart-mini-item__remove-spinner"></div>';
        // Adicionar loader dentro do botão, mantendo o ícone visível mas opaco
        this._removeBtn.appendChild(loader);
        
        // Forçar reflow para garantir renderização imediata
        void loader.offsetHeight;
      } else {
        // Remover classe de loading
        this._removeBtn.classList.remove('cart-mini-item__remove--loading');
        // Remover spinner do botão de remover
        const loader = this._removeBtn.querySelector('.cart-mini-item__remove-loader');
        if (loader) {
          loader.remove();
        }
      }
    }
    
    /**
     * Re-encontrar elementos DOM após refresh do drawer
     * Útil quando o HTML foi substituído mas o componente ainda existe
     */
    _refreshElements() {
      // Se o rootElement não está mais no DOM, buscar o novo elemento no drawer atualizado
      if (!this._rootElement || !document.body.contains(this._rootElement)) {
        const drawer = document.getElementById('cart-drawer');
        if (!drawer) {
          return false;
        }
        
        // Buscar o novo elemento pelo itemKey
        const newRootElement = drawer.querySelector(`.cart-mini-item[data-item-key="${this._itemKey}"]`);
        if (!newRootElement) {
          return false;
        }
        
        // Atualizar referência do rootElement
        this._rootElement = newRootElement;
      }
      
      // Remover listeners antigos antes de atualizar referências
      if (this._isInitialized) {
        if (this._increaseBtn && this._handleIncrease) {
          this._increaseBtn.removeEventListener('click', this._handleIncrease);
        }
        if (this._decreaseBtn && this._handleDecrease) {
          this._decreaseBtn.removeEventListener('click', this._handleDecrease);
        }
        if (this._removeBtn && this._handleRemove) {
          this._removeBtn.removeEventListener('click', this._handleRemove);
        }
      }
      
      // Re-encontrar elementos usando o mesmo método do construtor
      const findElementByDataKey = (selector, attribute = 'data-item-key') => {
        const allElements = this._rootElement.querySelectorAll(selector);
        for (const el of allElements) {
          const attrValue = el.getAttribute(attribute);
          if (attrValue === this._itemKey) {
            return el;
          }
        }
        return null;
      };
      
      // Atualizar referências
      this._quantityInput = findElementByDataKey('input[data-item-key]', 'data-item-key') || 
                            this._rootElement.querySelector('input[data-item-key]');
      this._increaseBtn = findElementByDataKey('[data-cart-qty-increase]', 'data-item-key') || 
                         this._rootElement.querySelector('[data-cart-qty-increase]');
      this._decreaseBtn = findElementByDataKey('[data-cart-qty-decrease]', 'data-item-key') || 
                         this._rootElement.querySelector('[data-cart-qty-decrease]');
      this._removeBtn = findElementByDataKey('[data-cart-remove]', 'data-item-key') || 
                       this._rootElement.querySelector('[data-cart-remove]');
      
      // Se os elementos foram encontrados e o componente estava inicializado, re-attachar listeners
      if (this._isInitialized && this._increaseBtn && this._decreaseBtn) {
        const verifyElement = (element) => {
          return element && document.body.contains(element);
        };
        
        if (verifyElement(this._increaseBtn) && this._handleIncrease) {
          this._increaseBtn.addEventListener('click', this._handleIncrease);
        }
        if (verifyElement(this._decreaseBtn) && this._handleDecrease) {
          this._decreaseBtn.addEventListener('click', this._handleDecrease);
        }
        if (verifyElement(this._removeBtn) && this._handleRemove) {
          this._removeBtn.addEventListener('click', this._handleRemove);
        }
      }
      
      return !!(this._quantityInput && this._increaseBtn && this._decreaseBtn);
    }
    
    /**
     * Limpar event listeners e destruir componente
     */
    destroy() {
      if (!this._isInitialized) {
        return;
      }
      
      // Remover listeners
      if (this._increaseBtn && this._handleIncrease) {
        this._increaseBtn.removeEventListener('click', this._handleIncrease);
      }
      if (this._decreaseBtn && this._handleDecrease) {
        this._decreaseBtn.removeEventListener('click', this._handleDecrease);
      }
      if (this._removeBtn && this._handleRemove) {
        this._removeBtn.removeEventListener('click', this._handleRemove);
      }
      
      this._isInitialized = false;
    }
    
    /**
     * Getter para itemKey (para debug)
     */
    get itemKey() {
      return this._itemKey;
    }
  }
  
  /**
   * Gerenciador de Componentes do Carrinho
   * Mantém registro de todos os componentes e gerencia seu ciclo de vida
   */
  class CartItemComponentManager {
    constructor() {
      this._components = new Map(); // Map<itemKey, CartItemComponent>
    }
    
    /**
     * Inicializar componentes para todos os itens no drawer
     */
    init() {
      const drawer = document.getElementById('cart-drawer');
      if (!drawer) {
        console.warn('[CartItemManager] Drawer não encontrado para inicialização');
        return;
      }
      
      // Limpar componentes antigos
      this.destroyAll();
      
      // Encontrar todos os itens do carrinho
      const itemElements = drawer.querySelectorAll('.cart-mini-item[data-item-key]');
      
      if (itemElements.length === 0) {
        return;
      }
      
      itemElements.forEach((itemElement) => {
        const itemKey = itemElement.getAttribute('data-item-key');
        if (!itemKey) return;
        
        // Verificar se já existe componente para este itemKey
        if (this._components.has(itemKey)) {
          const existingComponent = this._components.get(itemKey);
          if (existingComponent && typeof existingComponent.destroy === 'function') {
            existingComponent.destroy();
          }
        }
        
        // Verificar se o elemento está realmente no DOM antes de criar componente
        if (!document.body.contains(itemElement)) {
          console.warn('[CartItemManager] Item element não está no DOM para itemKey:', itemKey);
          return;
        }
        
        // Criar e inicializar componente
        try {
          const component = new CartItemComponent(itemElement);
          component.init();
          this._components.set(itemKey, component);
        } catch (error) {
          console.error('[CartItemManager] Erro ao criar componente para itemKey', itemKey, ':', error);
        }
      });
      
      // Log para debug (apenas em desenvolvimento)
      if (this._components.size > 0) {
        console.log('[CartItemManager] Componentes inicializados:', this._components.size);
      }
    }
    
    /**
     * Destruir todos os componentes
     */
    destroyAll() {
      this._components.forEach((component, itemKey) => {
        component.destroy();
      });
      this._components.clear();
    }
    
    /**
     * Obter componente por itemKey
     * @param {string} itemKey
     * @returns {CartItemComponent|null}
     */
    getComponent(itemKey) {
      return this._components.get(itemKey) || null;
    }
  }
  
  // Criar instância global do gerenciador
  const cartItemManager = new CartItemComponentManager();
  
  // Event Delegation otimizado como solução principal
  // Isso funciona mesmo quando o HTML é substituído pelo refreshCartDrawer()
  function setupEventDelegation() {
    // Usar event delegation no drawer (que não é substituído)
    const drawer = document.getElementById('cart-drawer');
    if (!drawer) return;
    
    // Remover listeners anteriores se existirem
    drawer.removeEventListener('click', handleCartButtonClick);
    
    // Adicionar listener de event delegation (uma única vez)
    drawer.addEventListener('click', handleCartButtonClick);
  }
  
  // Handler de event delegation para todos os botões do carrinho
  function handleCartButtonClick(e) {
    const target = e.target;
    
    // Verificar se é um botão de quantidade ou remover
    const button = target.closest('[data-cart-qty-increase], [data-cart-qty-decrease], [data-cart-remove]');
    if (!button) return;
    
    // Obter o itemKey do botão ou do elemento pai
    const itemKey = button.getAttribute('data-item-key') || 
                    button.closest('[data-item-key]')?.getAttribute('data-item-key');
    
    if (!itemKey) {
      console.error('[CartDrawer] itemKey não encontrado para botão clicado');
      return;
    }
    
    // Prevenir comportamento padrão
    e.preventDefault();
    e.stopPropagation();
    
    // IMPORTANTE: Adicionar loader IMEDIATAMENTE antes de qualquer outra coisa
    const itemElement = button.closest('.cart-mini-item[data-item-key]');
    if (itemElement) {
      // Adicionar classe de loading
      itemElement.classList.add('cart-mini-item--loading');
      
      // Adicionar loader no botão de remover se for o botão de remover
      if (button.hasAttribute('data-cart-remove')) {
        button.classList.add('cart-mini-item__remove--loading');
        button.disabled = true;
        if (!button.querySelector('.cart-mini-item__remove-loader')) {
          const removeLoader = document.createElement('div');
          removeLoader.className = 'cart-mini-item__remove-loader';
          removeLoader.innerHTML = '<div class="cart-mini-item__remove-spinner"></div>';
          button.appendChild(removeLoader);
        }
      } else {
        // Adicionar loader no quantity wrapper para botões de quantidade
        const quantityWrapper = itemElement.querySelector('.cart-mini-item__quantity');
        if (quantityWrapper && !quantityWrapper.querySelector('.cart-mini-item__loader')) {
          const loader = document.createElement('div');
          loader.className = 'cart-mini-item__loader';
          loader.innerHTML = '<div class="cart-mini-item__spinner"></div>';
          quantityWrapper.appendChild(loader);
        }
        // Desabilitar botões de quantidade
        const qtyButtons = itemElement.querySelectorAll('[data-cart-qty-increase], [data-cart-qty-decrease]');
        qtyButtons.forEach(btn => btn.disabled = true);
      }
    }
    
    // Obter o componente correspondente
    const component = cartItemManager.getComponent(itemKey);
    
    // Se o componente existe e está inicializado, usar ele
    if (component && component._isInitialized) {
      // Verificar se já está processando para prevenir execuções duplicadas
      if (component._isProcessing) {
        // Remover loader que acabamos de adicionar
        if (itemElement) {
          itemElement.classList.remove('cart-mini-item--loading');
          const loader = itemElement.querySelector('.cart-mini-item__loader');
          if (loader) loader.remove();
          const removeLoader = itemElement.querySelector('.cart-mini-item__remove-loader');
          if (removeLoader) removeLoader.remove();
          button.disabled = false;
          const qtyButtons = itemElement.querySelectorAll('[data-cart-qty-increase], [data-cart-qty-decrease]');
          qtyButtons.forEach(btn => btn.disabled = false);
        }
        return;
      }
      
      // Verificar se os elementos do componente ainda estão válidos
      if (!component._quantityInput || !document.body.contains(component._quantityInput)) {
        component._refreshElements();
      }
      
      if (button.hasAttribute('data-cart-qty-increase')) {
        component.updateQuantity(1);
      } else if (button.hasAttribute('data-cart-qty-decrease')) {
        component.updateQuantity(-1);
      } else if (button.hasAttribute('data-cart-remove')) {
        component.remove();
      }
      return;
    }
    
    // Se não encontrou componente, criar temporário ou usar fallback
    if (!itemElement) {
      console.error('[CartDrawer] Item element não encontrado');
      // Remover loader que adicionamos
      button.closest('.cart-mini-item')?.classList.remove('cart-mini-item--loading');
      return;
    }
    
    // Criar componente temporário e executar ação
    try {
      const tempComponent = new CartItemComponent(itemElement);
      tempComponent.init();
      
      if (button.hasAttribute('data-cart-qty-increase')) {
        tempComponent.updateQuantity(1);
      } else if (button.hasAttribute('data-cart-qty-decrease')) {
        tempComponent.updateQuantity(-1);
      } else if (button.hasAttribute('data-cart-remove')) {
        tempComponent.remove();
      }
    } catch (error) {
      console.error('[CartDrawer] Erro ao criar componente temporário:', error);
      
      // Fallback final: executar ação diretamente via API (loader já foi adicionado acima)
      executeCartActionDirectly(button, itemKey);
    }
  }
  
  // Fallback: executar ação diretamente via API sem componente
  function executeCartActionDirectly(button, itemKey) {
    const itemElement = button.closest('.cart-mini-item[data-item-key]');
    
    // Loader já foi adicionado no handleCartButtonClick, não precisa adicionar novamente
    
    // Buscar carrinho e encontrar o item
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const itemIndex = cart.items.findIndex(item => item.key === itemKey);
        if (itemIndex === -1) {
          throw new Error('Item não encontrado no carrinho');
        }
        
        const targetLine = itemIndex + 1;
        
        if (button.hasAttribute('data-cart-qty-increase')) {
          const currentQty = cart.items[itemIndex].quantity;
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ line: targetLine, quantity: currentQty + 1 })
          });
        } else if (button.hasAttribute('data-cart-qty-decrease')) {
          const currentQty = cart.items[itemIndex].quantity;
          if (currentQty <= 1) return Promise.resolve();
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ line: targetLine, quantity: currentQty - 1 })
          });
        } else if (button.hasAttribute('data-cart-remove')) {
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ line: targetLine, quantity: 0 })
          });
        }
      })
      .then(response => {
        if (!response || !response.ok) return;
        return response.json();
      })
      .then(cart => {
        if (cart) {
          // Remover loading antes de atualizar
          if (itemElement) {
            itemElement.classList.remove('cart-mini-item--loading');
            const loader = itemElement.querySelector('.cart-mini-item__loader');
            if (loader) loader.remove();
          }
          refreshCartDrawer();
          updateCartCount(cart.item_count);
        }
      })
      .catch(error => {
        console.error('[CartDrawer] Erro ao executar ação diretamente:', error);
        // Remover loading em caso de erro
        if (itemElement) {
          itemElement.classList.remove('cart-mini-item--loading');
          const loader = itemElement.querySelector('.cart-mini-item__loader');
          if (loader) loader.remove();
        }
      });
  }
  
  // Inicializar componentes quando o DOM estiver pronto
  cartItemManager.init();
  
  // Configurar event delegation imediatamente
  setupEventDelegation();
  
  // Atualizar função openCartDrawer para configurar event delegation quando abrir
  const originalOpenCartDrawer = openCartDrawer;
  openCartDrawer = function() {
    originalOpenCartDrawer();
    // Garantir que event delegation está configurado quando o drawer abre
    setTimeout(() => {
      setupEventDelegation();
      cartItemManager.init();
    }, 100);
  };
  
  // Re-inicializar componentes após refresh do drawer
  const originalRefreshCartDrawer = refreshCartDrawer;
  refreshCartDrawer = function() {
    // Destruir componentes antes do refresh
    cartItemManager.destroyAll();
    
    // Chamar função original
    originalRefreshCartDrawer();
    
    // Função auxiliar para re-inicializar com retry logic
    const reinitComponents = (attempt = 1, maxAttempts = 3) => {
      const drawer = document.getElementById('cart-drawer');
      if (!drawer) {
        if (attempt < maxAttempts) {
          setTimeout(() => reinitComponents(attempt + 1, maxAttempts), 100 * attempt);
        }
        return;
      }
      
      // Verificar se há itens no drawer
      const itemElements = drawer.querySelectorAll('.cart-mini-item[data-item-key]');
      if (itemElements.length === 0) {
        return;
      }
      
      // Tentar inicializar componentes
      try {
        cartItemManager.init();
        const initializedCount = cartItemManager._components ? cartItemManager._components.size : 0;
        
        // Verificar se todos os itens foram inicializados
        if (initializedCount < itemElements.length && attempt < maxAttempts) {
          setTimeout(() => reinitComponents(attempt + 1, maxAttempts), 100 * attempt);
        }
      } catch (error) {
        console.error('[CartDrawer] Erro ao re-inicializar componentes:', error);
        if (attempt < maxAttempts) {
          setTimeout(() => reinitComponents(attempt + 1, maxAttempts), 100 * attempt);
        }
      }
    };
    
    // Re-inicializar componentes após um delay (para garantir que o DOM foi atualizado)
    setTimeout(() => {
      reinitComponents();
      // Re-configurar event delegation após refresh
      setupEventDelegation();
    }, 150);
  };

  document.addEventListener('crown:refresh-mini-cart', function () {
    refreshCartDrawer();
  });
  
  // Re-inicializar componentes quando o drawer é aberto automaticamente
  document.addEventListener('theme:cart:update', function(event) {
    // Se veio do formulário de produto (adicionar ao carrinho)
    if (event.detail?.data?.source === 'product-form-component') {
      // Re-inicializar componentes após um delay para garantir que o drawer foi atualizado
      setTimeout(() => {
        try {
          cartItemManager.init();
        } catch (error) {
          console.error('[CartDrawer] Erro ao re-inicializar após evento:', error);
        }
      }, 200);
    }
  });

  // Funções legadas mantidas para compatibilidade (não usadas mais, mas podem ser chamadas por outros scripts)
  // A nova arquitetura usa CartItemComponent isolado
  function updateCartQuantity(line, change) {
    console.warn('updateCartQuantity (legado) chamado. Use CartItemComponent ao invés disso.');
    // Esta função pode ser removida no futuro após validação completa
  }

  function removeCartItem(line) {
    console.warn('removeCartItem (legado) chamado. Use CartItemComponent ao invés disso.');
    // Esta função pode ser removida no futuro após validação completa
  }

  // Atualizar conteúdo do drawer
  function refreshCartDrawer() {
    const currentDrawer = document.getElementById('cart-drawer');
    const currentOverlay = document.getElementById('cart-drawer-overlay');
    
    if (!currentDrawer) return;
    
    fetch(window.location.href)
      .then(response => response.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newDrawer = doc.getElementById('cart-drawer');
        
        if (newDrawer && currentDrawer) {
          // Preservar estado aberto
          const wasOpen = currentDrawer.classList.contains('open');
          const overlayWasOpen = currentOverlay && currentOverlay.classList.contains('open');
          
          // IMPORTANTE: Destruir componentes antes de substituir o HTML
          // Isso é feito pela função wrapper que substitui refreshCartDrawer
          
          // Substituir conteúdo
          currentDrawer.innerHTML = newDrawer.innerHTML;
          
          // Restaurar estado aberto
          if (wasOpen) {
            currentDrawer.classList.add('open');
          }
          if (overlayWasOpen && currentOverlay) {
            currentOverlay.classList.add('open');
          }
          
          // Os componentes serão re-inicializados pelo wrapper após um pequeno delay
        }
      })
      .catch(error => {
        console.error('Erro ao atualizar drawer:', error);
      });
  }

  // Atualizar contador do carrinho no header
  function updateCartCount(count) {
    const countElements = document.querySelectorAll('[data-cart-count], #cart-count, .header__cart-count, .header__mobile-cart-count, .cart-bubble__text-count');
    countElements.forEach(el => {
      el.textContent = count;
      
      // Atualizar visibilidade do bubble
      if (count === 0) {
        el.classList.add('hidden');
      } else {
        el.classList.remove('hidden');
      }
    });
  }

  // Funcionalidade de cupom - usando event delegation
  document.addEventListener('submit', function(e) {
    const couponForm = e.target.closest('#cart-drawer-coupon-form');
    if (!couponForm) return;

    e.preventDefault();
    
    const currentDrawer = document.getElementById('cart-drawer');
    if (!currentDrawer) return;

    const couponInput = couponForm.querySelector('input[name="discount"]');
    const couponError = currentDrawer.querySelector('#cart-drawer-coupon-error');
    
    if (!couponInput) return;

    const couponCode = couponInput.value.trim().toUpperCase();
    
    if (!couponCode) {
      showCouponError('Por favor, digite um código de cupom');
      return;
    }

    // Verificar se o cupom já está aplicado
    const existingPills = currentDrawer.querySelectorAll('[data-coupon-code]');
    const existingCodes = Array.from(existingPills)
      .map(pill => pill.dataset.couponCode)
      .filter(Boolean);
    
    if (existingCodes.includes(couponCode)) {
      showCouponError('Este cupom já está aplicado');
      couponInput.value = '';
      return;
    }

    // Ocultar erro anterior
    if (couponError) {
      couponError.classList.add('hidden');
      couponError.textContent = '';
    }

    // Desabilitar botão durante a requisição
    const submitBtn = couponForm.querySelector('button[type="submit"]');
    const originalBtnText = submitBtn.textContent;
    submitBtn.disabled = true;
    submitBtn.textContent = 'Aplicando...';

    // Preparar lista de cupons (adicionar o novo aos existentes)
    const allDiscountCodes = [...existingCodes, couponCode].filter(Boolean);

    // Aplicar cupom via API da Shopify
    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        discount: allDiscountCodes.join(',')
      })
    })
    .then(response => response.json())
    .then(data => {
      // Verificar se o cupom foi aplicado
      if (data.errors && Object.keys(data.errors).length > 0) {
        showCouponError('Cupom inválido ou não aplicável');
        return;
      }

      // Verificar se o cupom está na lista de cupons aplicados
      const discountCodes = data.discount_codes || [];
      const appliedCode = discountCodes.find(dc => 
        dc.code === couponCode && dc.applicable === true
      );

      if (!appliedCode) {
        showCouponError('Cupom inválido ou não aplicável');
        return;
      }

      // Limpar campo e atualizar drawer
      couponInput.value = '';
      refreshCartDrawer();
      updateCartCount(data.item_count || 0);
    })
    .catch(error => {
      console.error('Erro ao aplicar cupom:', error);
      showCouponError('Erro ao aplicar cupom. Tente novamente.');
    })
    .finally(() => {
      submitBtn.disabled = false;
      submitBtn.textContent = originalBtnText;
    });

    function showCouponError(message) {
      if (couponError) {
        couponError.textContent = message;
        couponError.classList.remove('hidden');
      }
    }
  });

  // Funcionalidade de remover cupom - usando event delegation
  document.addEventListener('click', function(e) {
    const removeBtn = e.target.closest('[data-coupon-remove]');
    if (!removeBtn) return;

    e.preventDefault();
    
    const currentDrawer = document.getElementById('cart-drawer');
    if (!currentDrawer) return;

    const couponCode = removeBtn.dataset.couponRemove;
    if (!couponCode) return;

    // Buscar todos os cupons aplicados
    const couponPills = currentDrawer.querySelectorAll('[data-coupon-code]');
    const appliedCodes = Array.from(couponPills)
      .map(pill => pill.dataset.couponCode)
      .filter(Boolean)
      .filter(code => code !== couponCode);

    // Desabilitar botão
    removeBtn.disabled = true;

    // Preparar payload para remover cupom
    const updatePayload = {};
    if (appliedCodes.length > 0) {
      updatePayload.discount = appliedCodes.join(',');
    } else {
      // Se não há mais cupons, passar string vazia para remover todos
      updatePayload.discount = '';
    }

    // Remover cupom via API da Shopify
    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(updatePayload)
    })
    .then(response => response.json())
    .then(data => {
      // Atualizar drawer
      refreshCartDrawer();
      updateCartCount(data.item_count || 0);
    })
    .catch(error => {
      console.error('Erro ao remover cupom:', error);
    })
    .finally(() => {
      removeBtn.disabled = false;
    });
  });

  // Formatação automática do campo CEP
  document.addEventListener('input', function(e) {
    const shippingInput = e.target;
    if (shippingInput.id === 'cart-drawer-shipping-input' || shippingInput.name === 'shipping') {
      let value = shippingInput.value.replace(/\D/g, '');
      if (value.length > 5) {
        value = value.substring(0, 5) + '-' + value.substring(5, 8);
      }
      shippingInput.value = value;
    }
  });

  // Funcionalidade de cálculo de frete - usando event delegation
  document.addEventListener('submit', function(e) {
    const shippingForm = e.target.closest('#cart-drawer-shipping-form');
    if (!shippingForm) return;

    e.preventDefault();
    
    const currentDrawer = document.getElementById('cart-drawer');
    if (!currentDrawer) return;

    const shippingInput = shippingForm.querySelector('input[name="shipping"]');
    const shippingError = currentDrawer.querySelector('#cart-drawer-shipping-error');
    const shippingResults = currentDrawer.querySelector('#cart-drawer-shipping-results');
    
    if (!shippingInput) return;

    // Limpar e remover resultados anteriores
    if (shippingError) {
      shippingError.classList.add('hidden');
      shippingError.textContent = '';
    }
    if (shippingResults) {
      shippingResults.remove();
    }

    // Obter e validar CEP
    let cep = shippingInput.value.replace(/\D/g, '');
    
    if (cep.length !== 8) {
      showShippingError('Por favor, digite um CEP válido (8 dígitos)');
      return;
    }

    // Formatar CEP para exibição
    const formattedCep = cep.substring(0, 5) + '-' + cep.substring(5, 8);

    // Desabilitar botão durante a requisição
    const submitBtn = shippingForm.querySelector('button[type="submit"]');
    const originalBtnText = submitBtn.textContent;
    submitBtn.disabled = true;
    submitBtn.textContent = 'Calculando...';

    // Calcular frete usando a API do Shopify
    calculateShipping(cep)
      .then(shippingRates => {
        if (shippingRates && shippingRates.length > 0) {
          displayShippingResults(shippingRates, formattedCep);
        } else {
          showShippingError('Nenhuma opção de frete disponível para este CEP');
        }
      })
      .catch(error => {
        console.error('Erro ao calcular frete:', error);
        showShippingError(error.message || 'Erro ao calcular frete. Tente novamente.');
      })
      .finally(() => {
        submitBtn.disabled = false;
        submitBtn.textContent = originalBtnText;
      });

    function showShippingError(message) {
      // Criar ou obter elemento de erro
      let errorEl = currentDrawer.querySelector('#cart-drawer-shipping-error');
      if (!errorEl) {
        errorEl = document.createElement('div');
        errorEl.id = 'cart-drawer-shipping-error';
        errorEl.className = 'cart-drawer-mini__coupon-error hidden';
        const inputWrapper = shippingForm.closest('.cart-drawer-mini__input-wrapper');
        if (inputWrapper) {
          inputWrapper.appendChild(errorEl);
        }
      }
      errorEl.textContent = message;
      errorEl.classList.remove('hidden');
    }

    function displayShippingResults(rates, cep) {
      // Remover resultados anteriores
      const existingResults = currentDrawer.querySelector('#cart-drawer-shipping-results');
      if (existingResults) {
        existingResults.remove();
      }

      // Criar container de resultados
      const resultsContainer = document.createElement('div');
      resultsContainer.id = 'cart-drawer-shipping-results';
      resultsContainer.className = 'cart-drawer-mini__shipping-results';

      // Header com CEP
      const header = document.createElement('div');
      header.className = 'cart-drawer-mini__shipping-header';
      header.innerHTML = `
        <span class="cart-drawer-mini__shipping-cep">CEP: ${cep}</span>
        <button type="button" class="cart-drawer-mini__shipping-close" aria-label="Fechar opções de frete">
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="2">
            <line x1="3" y1="3" x2="11" y2="11"/>
            <line x1="11" y1="3" x2="3" y2="11"/>
          </svg>
        </button>
      `;

      // Lista de opções de frete
      const ratesList = document.createElement('div');
      ratesList.className = 'cart-drawer-mini__shipping-rates';

      rates.forEach(rate => {
        const rateItem = document.createElement('div');
        rateItem.className = 'cart-drawer-mini__shipping-rate';
        rateItem.innerHTML = `
          <div class="cart-drawer-mini__shipping-rate-info">
            <span class="cart-drawer-mini__shipping-rate-name">${rate.name || rate.title || 'Frete'}</span>
            ${rate.delivery_range ? `<span class="cart-drawer-mini__shipping-rate-time">${rate.delivery_range}</span>` : ''}
          </div>
          <span class="cart-drawer-mini__shipping-rate-price">${formatShippingPrice(rate)}</span>
        `;
        ratesList.appendChild(rateItem);
      });

      resultsContainer.appendChild(header);
      resultsContainer.appendChild(ratesList);

      const resultsHost = currentDrawer.querySelector('#cart-drawer-shipping-results-container');
      if (resultsHost) {
        resultsHost.appendChild(resultsContainer);
      }

      // Handler para fechar resultados
      const closeBtn = resultsContainer.querySelector('.cart-drawer-mini__shipping-close');
      if (closeBtn) {
        closeBtn.addEventListener('click', () => {
          resultsContainer.remove();
        });
      }
    }

    function formatShippingPrice(rate) {
      if (rate.priceLabel) return rate.priceLabel;
      if (rate.price != null) {
        const value = (rate.price / 100).toFixed(2);
        return 'R$ ' + value.replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      }
      return '—';
    }
  });

  const KOKFY_SHIPPING_API = 'https://calculo-frete-produto.kokfy.com/api/carrier/shopify';

  function getShopDomain() {
    const shippingForm = document.getElementById('cart-drawer-shipping-form');
    return shippingForm?.dataset.shopDomain || window.Shopify?.shop || '';
  }

  function parseKokfyPrice(priceString) {
    if (!priceString || typeof priceString !== 'string') return null;
    const normalized = priceString
      .replace(/[^\d,.-]/g, '')
      .replace(/\./g, '')
      .replace(',', '.');
    const value = parseFloat(normalized);
    return Number.isFinite(value) ? Math.round(value * 100) : null;
  }

  function mapKokfyRates(rates) {
    if (!Array.isArray(rates) || rates.length === 0) {
      return [];
    }

    return rates.map(rate => ({
      name: rate.name || 'Frete',
      delivery_range: rate.shipping_date || null,
      priceLabel: rate.price || null,
      price: parseKokfyPrice(rate.price)
    }));
  }

  /**
   * Calcular frete usando a mesma API do app Frete no Produto (Kokfy)
   */
  async function calculateShipping(cep) {
    const cartResponse = await fetch('/cart.js');
    if (!cartResponse.ok) {
      throw new Error('Erro ao carregar carrinho');
    }

    const cart = await cartResponse.json();
    if (!cart?.items?.length) {
      throw new Error('Carrinho vazio');
    }

    const cleanCep = cep.replace(/\D/g, '');
    const shop = getShopDomain();
    if (!shop) {
      throw new Error('Loja não identificada');
    }

    const response = await fetch(`${KOKFY_SHIPPING_API}?shop=${encodeURIComponent(shop)}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: cart.items.map(item => ({
          variant_id: item.variant_id,
          price: item.price,
          quantity: String(item.quantity),
          sku: item.sku || ''
        })),
        cep: cleanCep,
        shop,
        origin: window.location.hostname
      })
    });

    if (!response.ok) {
      throw new Error('Erro ao calcular frete. Tente novamente.');
    }

    const rates = await response.json();
    const mappedRates = mapKokfyRates(rates);

    if (!mappedRates.length) {
      throw new Error('Nenhuma opção de frete disponível para este CEP');
    }

    return mappedRates;
  }
});
